<template>
<div class="chapter">
<div class="inner_page">
<div class="galley-rw">
<section class="frontmatter-rw BookTitlePage-rw exclude-print-rw page-open-left-rw" epub:type="frontmatter titlepage" id="BookTitlePage1"><div class="title-block-book-rw" id="title-block-book1"><h1 epub:type="fulltitle" id="h14">Talking Dirty</h1><p class="title-author-rw" id="title-author1">Elliott James</p></div><div class="imprint-rw" epub:type="imprint"><p id="p1"> </p><p id="p2">www.orbitbooks.net</p><p id="p3">www.orbitshortfiction.com</p></div></section>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// s001-BookTitlePage-01.vue?7e66359e